<template>
  <div class="signup-complete-container">
    <div class="logo"><img src="@/assets/logo.png" /></div>
    <div>
      <div class="thankyou">
        <p>ご登録ありがとうございます。</p>
        <p>5秒後に自動で画面を移動します。</p>
      </div>
    </div>

    <div class="actions">
      <div class="nav">
        <a @click="move"
          >自動で画面が移動しない場合は<br />こちらをクリックしてください。</a
        >
      </div>
    </div>
  </div>
</template>

<script>
import { AmplifyEventBus } from "aws-amplify-vue";

export default {
  data() {
    return {
      moved: false,
    };
  },
  mounted() {
    setTimeout(() => {
      this.move();
    }, 5000);
  },
  methods: {
    move() {
      if (this.moved) {
        return;
      }
      this.moved = true;
      AmplifyEventBus.$emit("authState", "signedIn");
    },
  },
};
</script>

<style lang="scss">
.signup-complete-container {
  width: 100vw;
  background: #ffffff;
  padding: 3rem;
  color: var(--purple);

  .desktop & {
    width: 552px;
    box-shadow: 0px 0px 20px #00000029;
    border-radius: 25px;
  }

  .logo {
    height: 3rem;
    margin-bottom: 2rem;
    display: flex;
    justify-content: center;

    img {
      object-fit: contain;
    }
  }

  .title {
    margin-bottom: 1rem;
    font-weight: 600;
    text-align: center;
  }

  .thankyou {
    text-align: center;
  }

  .actions {
    margin-top: 3rem;
    display: flex;
    align-items: center;
    flex-direction: column;

    .desktop & {
      margin-top: 4rem;
    }

    &.disable {
      cursor: none;
      pointer-events: none;
      opacity: 0.5;
    }

    .nav {
      color: #1a82b7;
      cursor: pointer;

      .mobile & {
        margin-top: 3rem;
      }

      a:active {
        opacity: 0.5;
      }
    }
  }
}
</style>
